import type { AiRelatedCompany, OCCompany } from 'bundles/connect/types';

export const selectOffMarketAiCompanies = (state): AiRelatedCompany[] => {
  return state.offMarketProperty.aiRelatedCompanies;
};

export const selectOffMarketOcCompany = (state): OCCompany => {
  return state.offMarketProperty.ocCompany;
};

export const selectOffMarketPropertyId = (state): string => {
  return state.offMarketProperty.propertyId;
};
